const passStorageKey = (key) => `manteo.embedCaptcha.${key}`;

export const readStoredPass = (key) => {
  if (!key) return '';
  try {
    return localStorage.getItem(passStorageKey(key)) || '';
  } catch {
    return '';
  }
};

export const writeStoredPass = (key, pass) => {
  if (!key || !pass) return;
  try {
    localStorage.setItem(passStorageKey(key), pass);
  } catch {
    // The pass in memory still covers this visit.
  }
};

export const clearStoredPass = (key) => {
  if (!key) return;
  try {
    localStorage.removeItem(passStorageKey(key));
  } catch {
    // Ignore storage failures and fall through to the challenge.
  }
};
